/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsSubsidyDtoCouponGetInfV2,
    JpCoBenefitoneBsSubsidyDtoCouponGetInfV2FromJSON,
    JpCoBenefitoneBsSubsidyDtoCouponGetInfV2FromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoCouponGetInfV2ToJSON,
} from './JpCoBenefitoneBsSubsidyDtoCouponGetInfV2';
import {
    JpCoBenefitoneBsSubsidyDtoGroupGetInfV2,
    JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSON,
    JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoGroupGetInfV2ToJSON,
} from './JpCoBenefitoneBsSubsidyDtoGroupGetInfV2';
import {
    JpCoBenefitoneBsSubsidyDtoPrice,
    JpCoBenefitoneBsSubsidyDtoPriceFromJSON,
    JpCoBenefitoneBsSubsidyDtoPriceFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoPriceToJSON,
} from './JpCoBenefitoneBsSubsidyDtoPrice';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableDataV2
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableDataV2 {
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableDataV2}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    tlementNo?: JpCoBenefitoneBsSubsidyDtoAvailableDataV2;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    subsidyDetailId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    dispSubsidyNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    subsidyId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    receptionDateFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    receptionDateTo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    applicableDateFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    applicableDateTo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    subsidyType?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    settlementNo?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    requestType?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    applicableDegreeCnt?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    personAccompanyFlg?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    minTgtAge?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    usedFormDiv?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    usedLimTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    usedLimUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    usedMaxCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    usedMaxTotalAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    parsonalUsedMaxCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    parsonalUsedMaxTotalAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    usedExpectedAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    yearEndDatetime?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    useStopFlg?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    subsidySts?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    requestDate?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    requestUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    approvalDate?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    approvalUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    minChargeAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    costUnderChargeableFlg?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    fiveDaysAgoControlFlg?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    dispMyPage?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    dispNoteComment?: string;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsSubsidyDtoPrice>}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    priceList?: Array<JpCoBenefitoneBsSubsidyDtoPrice>;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsSubsidyDtoCouponGetInfV2>}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    couponInfo?: Array<JpCoBenefitoneBsSubsidyDtoCouponGetInfV2>;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    subsidyClass?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    multipleUnusableFlg?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    targetService?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    auxiliaryType?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoGroupGetInfV2}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableDataV2
     */
    groupInfo?: JpCoBenefitoneBsSubsidyDtoGroupGetInfV2;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableDataV2 {
    return JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableDataV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tlementNo': !exists(json, 'tlementNo') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableDataV2FromJSON(json['tlementNo']),
        'subsidyDetailId': !exists(json, 'subsidyDetailId') ? undefined : json['subsidyDetailId'],
        'dispSubsidyNm': !exists(json, 'dispSubsidyNm') ? undefined : json['dispSubsidyNm'],
        'subsidyId': !exists(json, 'subsidyId') ? undefined : json['subsidyId'],
        'receptionDateFrom': !exists(json, 'receptionDateFrom') ? undefined : json['receptionDateFrom'],
        'receptionDateTo': !exists(json, 'receptionDateTo') ? undefined : json['receptionDateTo'],
        'applicableDateFrom': !exists(json, 'applicableDateFrom') ? undefined : json['applicableDateFrom'],
        'applicableDateTo': !exists(json, 'applicableDateTo') ? undefined : json['applicableDateTo'],
        'subsidyType': !exists(json, 'subsidyType') ? undefined : json['subsidyType'],
        'settlementNo': !exists(json, 'settlementNo') ? undefined : json['settlementNo'],
        'requestType': !exists(json, 'requestType') ? undefined : json['requestType'],
        'applicableDegreeCnt': !exists(json, 'applicableDegreeCnt') ? undefined : json['applicableDegreeCnt'],
        'personAccompanyFlg': !exists(json, 'personAccompanyFlg') ? undefined : json['personAccompanyFlg'],
        'minTgtAge': !exists(json, 'minTgtAge') ? undefined : json['minTgtAge'],
        'usedFormDiv': !exists(json, 'usedFormDiv') ? undefined : json['usedFormDiv'],
        'usedLimTerm': !exists(json, 'usedLimTerm') ? undefined : json['usedLimTerm'],
        'usedLimUnit': !exists(json, 'usedLimUnit') ? undefined : json['usedLimUnit'],
        'usedMaxCnt': !exists(json, 'usedMaxCnt') ? undefined : json['usedMaxCnt'],
        'usedMaxTotalAmt': !exists(json, 'usedMaxTotalAmt') ? undefined : json['usedMaxTotalAmt'],
        'parsonalUsedMaxCnt': !exists(json, 'parsonalUsedMaxCnt') ? undefined : json['parsonalUsedMaxCnt'],
        'parsonalUsedMaxTotalAmt': !exists(json, 'parsonalUsedMaxTotalAmt') ? undefined : json['parsonalUsedMaxTotalAmt'],
        'usedExpectedAmt': !exists(json, 'usedExpectedAmt') ? undefined : json['usedExpectedAmt'],
        'yearEndDatetime': !exists(json, 'yearEndDatetime') ? undefined : json['yearEndDatetime'],
        'useStopFlg': !exists(json, 'useStopFlg') ? undefined : json['useStopFlg'],
        'subsidySts': !exists(json, 'subsidySts') ? undefined : json['subsidySts'],
        'requestDate': !exists(json, 'requestDate') ? undefined : json['requestDate'],
        'requestUserId': !exists(json, 'requestUserId') ? undefined : json['requestUserId'],
        'approvalDate': !exists(json, 'approvalDate') ? undefined : json['approvalDate'],
        'approvalUserId': !exists(json, 'approvalUserId') ? undefined : json['approvalUserId'],
        'minChargeAmt': !exists(json, 'minChargeAmt') ? undefined : json['minChargeAmt'],
        'costUnderChargeableFlg': !exists(json, 'costUnderChargeableFlg') ? undefined : json['costUnderChargeableFlg'],
        'fiveDaysAgoControlFlg': !exists(json, 'fiveDaysAgoControlFlg') ? undefined : json['fiveDaysAgoControlFlg'],
        'dispMyPage': !exists(json, 'dispMyPage') ? undefined : json['dispMyPage'],
        'dispNoteComment': !exists(json, 'dispNoteComment') ? undefined : json['dispNoteComment'],
        'priceList': !exists(json, 'priceList') ? undefined : ((json['priceList'] as Array<any>).map(JpCoBenefitoneBsSubsidyDtoPriceFromJSON)),
        'couponInfo': !exists(json, 'couponInfo') ? undefined : ((json['couponInfo'] as Array<any>).map(JpCoBenefitoneBsSubsidyDtoCouponGetInfV2FromJSON)),
        'subsidyClass': !exists(json, 'subsidyClass') ? undefined : json['subsidyClass'],
        'multipleUnusableFlg': !exists(json, 'multipleUnusableFlg') ? undefined : json['multipleUnusableFlg'],
        'targetService': !exists(json, 'targetService') ? undefined : json['targetService'],
        'auxiliaryType': !exists(json, 'auxiliaryType') ? undefined : json['auxiliaryType'],
        'groupInfo': !exists(json, 'groupInfo') ? undefined : JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSON(json['groupInfo']),
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableDataV2ToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableDataV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tlementNo': JpCoBenefitoneBsSubsidyDtoAvailableDataV2ToJSON(value.tlementNo),
        'subsidyDetailId': value.subsidyDetailId,
        'dispSubsidyNm': value.dispSubsidyNm,
        'subsidyId': value.subsidyId,
        'receptionDateFrom': value.receptionDateFrom,
        'receptionDateTo': value.receptionDateTo,
        'applicableDateFrom': value.applicableDateFrom,
        'applicableDateTo': value.applicableDateTo,
        'subsidyType': value.subsidyType,
        'settlementNo': value.settlementNo,
        'requestType': value.requestType,
        'applicableDegreeCnt': value.applicableDegreeCnt,
        'personAccompanyFlg': value.personAccompanyFlg,
        'minTgtAge': value.minTgtAge,
        'usedFormDiv': value.usedFormDiv,
        'usedLimTerm': value.usedLimTerm,
        'usedLimUnit': value.usedLimUnit,
        'usedMaxCnt': value.usedMaxCnt,
        'usedMaxTotalAmt': value.usedMaxTotalAmt,
        'parsonalUsedMaxCnt': value.parsonalUsedMaxCnt,
        'parsonalUsedMaxTotalAmt': value.parsonalUsedMaxTotalAmt,
        'usedExpectedAmt': value.usedExpectedAmt,
        'yearEndDatetime': value.yearEndDatetime,
        'useStopFlg': value.useStopFlg,
        'subsidySts': value.subsidySts,
        'requestDate': value.requestDate,
        'requestUserId': value.requestUserId,
        'approvalDate': value.approvalDate,
        'approvalUserId': value.approvalUserId,
        'minChargeAmt': value.minChargeAmt,
        'costUnderChargeableFlg': value.costUnderChargeableFlg,
        'fiveDaysAgoControlFlg': value.fiveDaysAgoControlFlg,
        'dispMyPage': value.dispMyPage,
        'dispNoteComment': value.dispNoteComment,
        'priceList': value.priceList === undefined ? undefined : ((value.priceList as Array<any>).map(JpCoBenefitoneBsSubsidyDtoPriceToJSON)),
        'couponInfo': value.couponInfo === undefined ? undefined : ((value.couponInfo as Array<any>).map(JpCoBenefitoneBsSubsidyDtoCouponGetInfV2ToJSON)),
        'subsidyClass': value.subsidyClass,
        'multipleUnusableFlg': value.multipleUnusableFlg,
        'targetService': value.targetService,
        'auxiliaryType': value.auxiliaryType,
        'groupInfo': JpCoBenefitoneBsSubsidyDtoGroupGetInfV2ToJSON(value.groupInfo),
    };
}

